var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1231 13.9057C13.1231 14.1905 13.0105 14.4636 12.8101 14.665C12.6097 14.8664 12.3378 14.9795 12.0544 14.9795H2.43591C2.15247 14.9795 1.88063 14.8664 1.68021 14.665C1.47978 14.4636 1.36719 14.1905 1.36719 13.9057V2.09338C1.36719 1.80858 1.47978 1.53544 1.68021 1.33405C1.88063 1.13267 2.15247 1.01953 2.43591 1.01953H9.38259L13.1231 4.77799V13.9057Z",
    stroke: "#999999",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3823 9.07422L7.24486 11.2219L5.10742 9.07422",
    stroke: "#999999",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24609 11.2226V5.31641",
    stroke: "#999999",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingDownload);
export default __webpack_public_path__ + "static/media/billingDownload.9436073e2a2681b725260693c157b94a.svg";
export { ForwardRef as ReactComponent };